/**
 * 内置策略：最近轿厢响应（设计文档 3.4 表 / F-007）。
 *
 * 为每个呼叫选择预计到达时间（ETA）最短的轿厢；空闲车严格优先于忙碌车；
 * 同 ETA 按 carId 字典序决胜（确定性）。
 * 通过 greedyAssign 做批次内载客感知，避免单梯过载。
 */
import type { DispatchStrategy, InitContext, SnapshotView } from '../strategy-api';
import { greedyAssign } from '../greedy-assign';
import { travelTimeForFloorsMs } from '../../core/physics/kinematics';
import type { KinematicsParams } from '../../core/physics/kinematics';

// 空闲车严格优先：忙闲惩罚须大于任意可能 ETA（机场 60 层 ETA 上界约 2×10^5ms）
const BUSY_PENALTY_MS = 1e9;

export function createNearestCarStrategy(id = 'nearest-car'): DispatchStrategy {
  let kin: KinematicsParams | undefined;
  return {
    id,
    init(ctx: InitContext) {
      kin = ctx.kinematics;
    },
    allocate(view: SnapshotView) {
      if (!kin) throw new Error('nearest-car: init() not called');
      const k = kin;
      return greedyAssign(view.cars, view.calls, (car, call) => {
        const busy = car.state === 'idle' ? 0 : BUSY_PENALTY_MS;
        const eta = travelTimeForFloorsMs(Math.abs(car.floor - call.floor), k);
        // C：方向亲和——正反向运行的忙碌车加罚，减少反向指派造成的绕行
        const opposite = car.state === 'moving' && car.direction !== 0 && car.direction !== call.direction;
        return busy + eta + (opposite ? Math.round(eta * 0.5) : 0);
      });
    },
  };
}
